var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination {\n  display: -ms-flexbox;\n  display: flex;\n  color: #666;\n}\n.page-number {\n  font-size: 14px;\n  padding: 2px 7px 2px;\n  background: #202020;\n  margin-right: 10px;\n  cursor: pointer;\n  border-radius: 5px;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n}\n.active {\n  color: #fff;\n}\n.arrow {\n  cursor: pointer;\n  background: #202020 no-repeat center center;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 7px 10px 7px;\n  margin-right: 15px;\n  border-radius: 5px;\n}\n.arrow-inactive {\n  background: #202020 no-repeat center center;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 7px 10px 7px;\n  margin-right: 15px;\n  border-radius: 5px;\n  opacity: 0.4;\n  filter: alpha(opacity=40);\n  /* For IE8 and earlier */\n}\n.arrow-left {\n  background-image: url(" + escape(require("../../../assets/img/left-arrow.png")) + ");\n  margin-right: 15px;\n}\n.arrow-right {\n  background-image: url(" + escape(require("../../../assets/img/right-arrow.png")) + ");\n  margin-left: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/pagination/pagination.component.less
// module id = ../../../../../src/app/shared/pagination/pagination.component.less
// module chunks = main